/**
 *  Dit bestand bevat alle javascript voor de trigger 'bereken wat je kunt lenen'.
 *  Hierin worden de sliders geactiveerd en wordt alle data verwerkt.
 **/

if ($('.hoeveel-kan-ik-lenen-trigger-js').length !== 0) {
    $(document).ready(function(){

        if($('#bereken_lening').length > 0){
            var numberFormatEuroOptions = { // format euro options
                numberOfDecimals: 0,
                decimalSeparator: ',',
                thousandSeparator: '.'
            };

            $('#bereken_lening').find('input[type="text"]').click(function(){
                $(this).select();
            });

            // //wanneer je iets intypt in het edit vakje van bereken je lening. Wat er gebeurt nadat je 1 key loslaat
            $("#bereken_lening").find('div.no-slider').children('input[type="text"]').keyup(function(){
                value = $(this).val(); //het bedrag

                if(value > 5000){ //als het bedrag hoger is dan 5000 moet het bedrag 5000 worden
                    value = 5000;
                }else if( value < 0 ){ //als het bedrag lager is dan 0 moet het bedrag 0 worden
                    value = 0;
                }

                $(this).val(value); // stel opnieuw de waarde in.

                var id = $(this).data('holder'); //haal het id van het corresponderende veld op dat de data moet vasthouden
                $('input#' + id).val(value); //stel het juiste getal in van dit veld

                changeBedrag(); // verwerk alle data

            });

            $('#bereken_lening').find('input[type="radio"]').on('click', function(){
                var id = $(this).data('holder'); //haal het id van het corresponderende veld op dat de data moet vasthouden
                $('input#' + id).val($(this).val()); //stel de juiste waarde in van dit veld
                changeBedrag(); //verwerk alle data
            });


             setSlider = function (elem, min, max, startVal, step, callback) {

                min = typeof min == 'undefined' ? 0 : Number(min);
                max = typeof max == 'undefined' ? 75000 : Number(max);
                startVal = typeof startVal == 'undefined' ? 0 : Number(startVal);
                step = typeof step == 'undefined' ? 0 : Number(step);
                parentElem = elem.parent().attr('class');

                elem.ionRangeSlider({
                    from: startVal,
                    min: min,
                    max: max,
                    step: step,
                    onStart: function(data) {
                        dataHolder = $(data.input[0]).data('holder');
                        $('input[id="'+dataHolder+'"]').val(data.from);
                        $(parentElem + ' .rails').css({backgroundPosition: '0 -6px'});
                    },
                    onChange: function(data) {
                        dataHolder = $(data.input[0]).data('holder');
                        $('input[id="'+dataHolder+'"]').val(data.from);
                        changeBedrag();
                    }
                });

                $('input[type="text"]#'+elem.data('holder')).on('keyup', function(e){
                    value = $(this).val(); //het bedrag

                    if(value > 5000){ //als het bedrag hoger is dan 5000 moet het bedrag 5000 worden
                        value = 5000;
                    }else if( value < 0 ){ //als het bedrag lager is dan 0 moet het bedrag 0 worden
                        value = 0;
                    }

                    $(this).val(value); // stel opnieuw de waarde in.

                    var id = $(this).data('holder'); //haal het id van het corresponderende veld op dat de data moet vasthouden
                    $('input#' + id).val(value); //stel het juiste getal in van dit veld

                       elem.data('ionRangeSlider').update({
                            from : value
                       });

                    changeBedrag(); // verwerk alle data

                });

                changeBedrag();
            };

        }

        $('#bereken_lening').find('.slider').each(function(index, el) {
            setSlider($(this), $(this).attr('min'), $(this).attr('max'), $(this).attr('start-val'), $(this).attr('step'));
        });

    });

    function changeBedrag()
    {
        woning = $('#bereken_lening').find("input#woning").val();
        leefsituatie = $('#bereken_lening').find("input#leefsituatie").val();
        kind = $('#bereken_lening').find("input#kind").val();
        woonlasten = Number($('#bereken_lening').find("input#woonlast").val());
        nettoInkomen = Number($('#bereken_lening').find("input#netto-inkomen").val());
        nettoInkomenPartner = Number($('#bereken_lening').find("input#netto-inkomen-partner").val());
        heffingskorting = 124;

        // console.log(nettoInkomen);

        if(woning == 'huur')
        {
            $('label.woonlast-label').text('Kale huur per maand:');
        }else{
            $('label.woonlast-label').text('Bruto hypotheeklast per maand:');
        }

        if(leefsituatie == 'alleenstaand')
        {
            nettoInkomenPartner = 0;
            $('div.row.partner').hide();
        }else{
            $('div.row.partner').show();
        }


        inkomsten = nettoInkomen+nettoInkomenPartner;
        inkomsten_woning = inkomsten;

        if(woning!='huur'){
            if(inkomsten > 3446)
            {
                woonlasten = 0.70 * woonlasten;
            }else{
                woonlasten = 0.75 * woonlasten;
            }
        }


        if(leefsituatie == 'alleenstaand')
        {
            if(kind == 'ja'){
                norm = 931;
                basishuur = 227;
                maximalisatie = 2877;
                vasteKosten = 1189;
            }else{
                norm = 723;
                basishuur = 227;
                maximalisatie = 3035;
                vasteKosten = 1036;
            }
        }
        else
        {
            if(nettoInkomenPartner == 0)
            {
                nettoInkomen = (nettoInkomen + heffingskorting);
                inkomsten = (inkomsten + heffingskorting);
            }

            if(kind == 'ja'){
                norm = 1273;
                basishuur = 227;
                maximalisatie = 2877;
                vasteKosten = 1479.55;
            }else{
                norm = 1172;
                basishuur = 227;
                maximalisatie = 3035;
                vasteKosten = 1417.40;
            }
        }

        levensonderhoud = (0.15 * ((nettoInkomen + nettoInkomenPartner) - basishuur - norm)) + norm;

        if(inkomsten > maximalisatie)
        {
            levensonderhoud = vasteKosten;
        }

        termijnbedrag = inkomsten - woonlasten - levensonderhoud;

        leencapaciteit =  Math.ceil(termijnbedrag * 50);

        if(leencapaciteit < 0)
            leencapaciteit = 0;
        else
            leencapaciteit = leencapaciteit;

        if(leencapaciteit == 0)
        {
            leenbedrag = "€ 0,-";
            leenbedragRaw = leencapaciteit.toFixed(0);
        }
        else
        {
            var leenbedrag = $().number_format(leencapaciteit.toFixed(0), numberFormatEuroOptions);
            leenbedrag = "€ " + leenbedrag + ",-";
            leenbedragRaw = leencapaciteit.toFixed(0);
        }

        $("#bereken_lening").find('p.total').text('U kunt '+ leenbedrag +' lenen' );
        $("#LeningBedrag-right").val(leenbedragRaw);
        $("#LeningBedrag").val(leenbedragRaw);
        $("h3.leenbedrag").text(leenbedrag);
    }


    $(window).load(function() {
        /* Act on the event */
        if($('#bereken_lening').length > 0){
            window.changeBedrag();
        }

    });
}